import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {RcnPriceStatsQuery} from "../types/RcnPriceStatsQuery";
import {RcnPriceStatsResponse} from "../types/RcnPriceStatsResponse";
import {RcnRegionsPriceStatsQuery, RcnRegionsPriceStatsResponse} from "../types/RcnRegionsPriceStats";

export const getRcnDataApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getRcnData: build.query<RcnPriceStatsResponse, RcnPriceStatsQuery>({
            queryFn: async ({regionId, address, ...filters}, _api, _extraOptions, baseQuery) => {
                const url = regionId !== undefined ? apiV2Link.region.priceStats({regionId}) : apiV2Link.address.priceStats();
                const query = Object.fromEntries(Object.entries({...filters, ...address}).filter(([, value]) => value != null));

                const result = await baseQuery({url, params: query});
                if (result.error) {
                    return {error: result.error};
                }

                const data = result.data as RcnPriceStatsResponse | null;
                if (!data || !Array.isArray(data.series)) {
                    return {error: {status: "CUSTOM_ERROR", error: "Unexpected RCN price stats response"}};
                }
                return {data};
            }
        }),
        // Many regions in one round trip. Callers must pass regionIds already sorted - the array is part of
        // the RTK Query cache key, so a different order would hash as a separate entry and refetch.
        getRcnRegionsData: build.query<RcnRegionsPriceStatsResponse, RcnRegionsPriceStatsQuery>({
            queryFn: async ({regionIds, ...filters}, _api, _extraOptions, baseQuery) => {
                if (regionIds.length === 0) {
                    return {error: {status: "CUSTOM_ERROR", error: "RCN region stats require at least one region id"}};
                }

                const query = Object.fromEntries(Object.entries({...filters, region_ids: regionIds.join(",")}).filter(([, value]) => value != null));

                const result = await baseQuery({url: apiV2Link.region.regionsPriceStats(), params: query});
                if (result.error) {
                    return {error: result.error};
                }

                const data = result.data as RcnRegionsPriceStatsResponse | null;
                if (!data || !Array.isArray(data.results)) {
                    return {error: {status: "CUSTOM_ERROR", error: "Unexpected RCN region price stats response"}};
                }
                return {data};
            }
        })
    })
});

export const {useGetRcnDataQuery} = getRcnDataApi;
import {apiV2Link} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../app/api/rp_api";
import {RcnPriceStatsQuery} from "../types/RcnPriceStatsQuery";
import {RcnPriceStatsResponse} from "../types/RcnPriceStatsResponse";
import {RcnRegionsPriceStatsQuery, RcnRegionsPriceStatsResponse} from "../types/RcnRegionsPriceStats";

export const getRcnDataApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getRcnData: build.query<RcnPriceStatsResponse, RcnPriceStatsQuery>({
            queryFn: async ({regionId, address, ...filters}, _api, _extraOptions, baseQuery) => {
                const url = regionId !== undefined ? apiV2Link.region.priceStats({regionId}) : apiV2Link.address.priceStats();
                const query = Object.fromEntries(Object.entries({...filters, ...address}).filter(([, value]) => value != null));

                const result = await baseQuery({url, params: query});
                if (result.error) {
                    return {error: result.error};
                }

                const data = result.data as RcnPriceStatsResponse | null;
                if (!data || !Array.isArray(data.series)) {
                    return {error: {status: "CUSTOM_ERROR", error: "Unexpected RCN price stats response"}};
                }
                return {data};
            }
        }),
        // Many regions in one round trip. Callers must pass regionIds already sorted - the array is part of
        // the RTK Query cache key, so a different order would hash as a separate entry and refetch.
        getRcnRegionsData: build.query<RcnRegionsPriceStatsResponse, RcnRegionsPriceStatsQuery>({
            queryFn: async ({regionIds, ...filters}, _api, _extraOptions, baseQuery) => {
                if (regionIds.length === 0) {
                    return {error: {status: "CUSTOM_ERROR", error: "RCN region stats require at least one region id"}};
                }

                const query = Object.fromEntries(Object.entries({...filters, region_ids: regionIds.join(",")}).filter(([, value]) => value != null));

                const result = await baseQuery({url: apiV2Link.region.regionsPriceStats(), params: query});
                if (result.error) {
                    return {error: result.error};
                }

                const data = result.data as RcnRegionsPriceStatsResponse | null;
                if (!data || !Array.isArray(data.results)) {
                    return {error: {status: "CUSTOM_ERROR", error: "Unexpected RCN region price stats response"}};
                }
                return {data};
            }
        })
    })
});

export const {useGetRcnDataQuery} = getRcnDataApi;
